import camelCase from 'camelcase';

import { appConfig } from '@config';
import { HTTP_VSUITE_MAINTENANCE } from '@constants/http-codes';
import ApiError from '@errors/ApiError';
import { intl } from '@helpers/intl';
import { reloadWithCounter } from '@helpers/location';

/**
 * Handle HTTP responses
 * @param {any} error - HTTP response code.
 * @returns {Promise<never>|void}
 */
const failErrorResponse = async error => {
  const status = error?.response?.status;

  if (status === HTTP_VSUITE_MAINTENANCE) {
    reloadWithCounter('maintenanceRefresh');
    return Promise.reject(new Error(`${appConfig.vsuite.name} is down for maintenance`));
  }

  const nonFieldErrors =
    error.message === 'Network Error'
      ? intl.formatMessage({
          id: 'global.notification.network-error-default',
          defaultMessage: 'Network error. Please check your connection and try again.',
        })
      : '';

  const responseErrors = error?.response?.data;

  const errors = responseErrors || {
    non_field_errors: [nonFieldErrors],
  };

  const errorObject = Object.keys(errors).reduce(
    (accumulator, currentValue) => {
      if (currentValue === 'non_field_errors') {
        return {
          ...accumulator,
          nonFieldErrors: errors[currentValue][0],
        };
      }

      if (currentValue === 'message' || currentValue === 'detail') {
        return {
          ...accumulator,
          nonFieldErrors: errors[currentValue],
        };
      }

      if (currentValue !== 'non_field_errors' && typeof errors[currentValue] === 'object') {
        return {
          ...accumulator,
          fieldErrors: {
            ...accumulator.fieldErrors,
            [camelCase(currentValue)]: errors[currentValue][0],
          },
        };
      }

      return accumulator;
    },
    { ...error, nonFieldErrors: '', fieldErrors: {} }
  );

  return Promise.reject(
    new ApiError({
      ...errorObject,
      hasFieldError: errorObject ? Object.keys(errorObject.fieldErrors).length > 0 : false,
      hasNonFieldError: errorObject ? errorObject.nonFieldErrors.length > 0 : false,
    })
  );
};

export default failErrorResponse;
